import { SUPPORTED_LANGUAGES, type SupportedLanguage } from '@wundo/shared/language.ts';

/*
 * Built from the shared list so a picker cannot drift from what the product
 * supports. Names stay in their own language — translating them hides the
 * option you are looking for.
 */
const LANGUAGE_NAMES: Record<SupportedLanguage, string> = {
  nl: 'Nederlands',
  fr: 'Français',
  en: 'English',
};

export const LANGUAGE_OPTIONS = SUPPORTED_LANGUAGES.map((value) => ({
  value,
  label: LANGUAGE_NAMES[value],
}));
